export const NEWSFLASH_LOGIN_REQUEST = 'NEWSFLASH_LOGIN_REQUEST'
export const NEWSFLASH_LOGIN_SUCCESS = 'NEWSFLASH_LOGIN_SUCCESS'
export const NEWSFLASH_LOGIN_FAIL = 'NEWSFLASH_LOGIN_FAIL'
export const NEWSFLASH_LOGOUT = 'NEWSFLASH_LOGOUT'

export const NEWSFLASH_REGISTER_REQUEST = 'NEWSFLASH_REGISTER_REQUEST'
export const NEWSFLASH_REGISTER_SUCCESS = 'NEWSFLASH_REGISTER_SUCCESS'
export const NEWSFLASH_REGISTER_FAIL = 'NEWSFLASH_REGISTER_FAIL'



export const NEWSFLASH_DETAILS_REQUEST = 'NEWSFLASHLOGUE_DETAILS_REQUEST'
export const NEWSFLASH_DETAILS_SUCCESS = 'NEWSFLASH_DETAILS_SUCCESS'
export const NEWSFLASH_DETAILS_FAIL = 'NEWSFLASH_DETAILS_FAIL'
export const NEWSFLASH_DETAILS_RESET = 'NEWSFLASH_DETAILS_RESET'

export const NEWSFLASH_UPDATE_PROFILE_REQUEST = 'NEWSFLASH_UPDATE_PROFILE_REQUEST'
export const NEWSFLASH_UPDATE_PROFILE_SUCCESS = 'NEWSFLASH_UPDATE_PROFILE_SUCCESS'
export const NEWSFLASH_UPDATE_PROFILE_FAIL = 'NEWSFLASH_UPDATE_PROFILE_FAIL'

export const NEWSFLASH_LIST_REQUEST = 'NEWSFLASH_LIST_REQUEST'
export const NEWSFLASH_LIST_SUCCESS = 'NEWSFLASH_LIST_SUCCESS'
export const NEWSFLASH_LIST_FAIL = 'NEWSFLASH_LIST_FAIL'
export const NEWSFLASH_LIST_RESET = 'NEWSFLASH_LIST_RESET'

export const NEWSFLASH_DELETE_REQUEST = 'NEWSFLASH_DELETE_REQUEST'
export const NEWSFLASH_DELETE_SUCCESS = 'NEWSFLASH_DELETE_SUCCESS'
export const NEWSFLASH_DELETE_FAIL = 'NEWSFLASH_DELETE_FAIL'

export const NEWSFLASH_UPDATE_REQUEST = 'NEWSFLASH_UPDATE_REQUEST'
export const NEWSFLASH_UPDATE_SUCCESS = 'NEWSFLASH_UPDATE_SUCCESS'
export const NEWSFLASH_UPDATE_FAIL = 'NEWSFLASH_UPDATE_FAIL'
export const NEWSFLASH_UPDATE_RESET = 'NEWSFLASH_UPDATE_RESET'
